import {Button} from '@ui/atoms/button';
import React from 'react';
import {
  SubmissionMeta,
  SubmissionMetaActions,
  SubmissionMetaDetails,
  SubmissionMetaTop,
  SubmissionProgressLabel,
  SubmissionProgressRow,
  SubmissionProgressTrack,
  SubmissionSender,
  SubmissionSentDate,
  CheckinStatusBadge,
} from '../my_checkins-style';

interface CheckinMetaCardProps {
  senderName?: string;
  sentLabel: string;
  dueLabel?: string;
  dueDateLabel?: string;
  isOverdue?: boolean;
  answered: number;
  total: number;
  percentage: number;
  showHistory: boolean;
  onToggleHistory: () => void;
  hasPastSubmissions?: boolean;
  canViewHistory?: boolean;
}

export const CheckinMetaCard: React.FC<CheckinMetaCardProps> = ({
  senderName,
  sentLabel,
  dueLabel,
  dueDateLabel,
  isOverdue,
  answered,
  total,
  percentage,
  showHistory,
  onToggleHistory,
  hasPastSubmissions = true,
  canViewHistory = true,
}) => {
  return (
    <SubmissionMeta>
      <SubmissionMetaTop>
        <SubmissionMetaDetails>
          <SubmissionSender>
            Sent by {senderName || 'Cycle creator'}
          </SubmissionSender>
          <SubmissionSentDate>{sentLabel}</SubmissionSentDate>
        </SubmissionMetaDetails>
        <SubmissionMetaActions>
          {(dueLabel || dueDateLabel) && (
            <CheckinStatusBadge
              data-testid="checkin-status-badge"
              variant={isOverdue ? 'danger' : 'warning'}>
              {dueLabel && <span className="due-state">{dueLabel}</span>}
              {dueDateLabel && <span>{dueDateLabel}</span>}
            </CheckinStatusBadge>
          )}
          {canViewHistory && hasPastSubmissions && (
            <Button
              kind="secondary"
              width="sm"
              type="button"
              style={{padding: '8px 12px'}}
              onClick={onToggleHistory}>
              {showHistory ? 'Hide history' : 'View history'}
            </Button>
          )}
        </SubmissionMetaActions>
      </SubmissionMetaTop>
      {total > 0 && (
        <SubmissionProgressRow>
          <SubmissionProgressTrack
            role="progressbar"
            aria-label="Required check-in responses completed"
            aria-valuemin={0}
            aria-valuemax={total}
            aria-valuenow={answered}>
            <span style={{width: `${percentage}%`}} />
          </SubmissionProgressTrack>
          <SubmissionProgressLabel>
            {answered} of {total} required responses
          </SubmissionProgressLabel>
        </SubmissionProgressRow>
      )}
    </SubmissionMeta>
  );
};
